module.exports = __webpack_public_path__ + "img/fmcs_yaliquxian.9dd85999.png";